import { validateAndTrackEntryPagesEvent } from '@vp/entry-pages-tracking-helpers'
import { TrackingPageZone } from './trackingTypes'
import { PAGE_NAME } from '../../utils/constants'

const DELAY_BEFORE_NAVIGATING_IN_MS = 300

export const schema = {
  type: 'object',
  properties: {
    category: {
      type: 'string',
      enum: ['Home Page', PAGE_NAME],
    },
    label: {
      type: 'string',
      pattern: `^Content:(?:${TrackingPageZone}|[^_\n]+_[^_\n]+_Row[1-9][0-9]*)$`,
    },
    eventDetail: {
      type: 'string',
      pattern: '^/[^;]*;/[^;]*;[^;]*;[^;]*$',
    },
    navigationDetail: {
      type: 'string',
      pattern: '^.+:([0-9][0-9]*)$',
    },
  },
  required: ['category', 'label', 'eventDetail', 'navigationDetail'],
  additionalProperties: true,
}

const createOnClickTrackingHandler = (trackingConfig, logger, href, openInNewTab) => {
  if (!trackingConfig) {
    return undefined
  }

  return (event) => {
    stopNavigation(event)
    validateAndTrackEntryPagesEvent(trackingConfig.eventName, trackingConfig.properties, schema, logger)

    if (href) {
      setTimeout(() => navigate(href, openInNewTab), DELAY_BEFORE_NAVIGATING_IN_MS)
    }
  }
}

const stopNavigation = (event) => event.preventDefault()

const navigate = (href, openLinkNewTab) => {
  if (openLinkNewTab) {
    window.open(href, '_blank', 'noopener,noreferrer')
  } else {
    window.location.href = href
  }
}

const getTrackingConfigLinkAttributes = (trackingData) => {
  const { ctaValue, subSection, position, pageZone } = trackingData
  const composedCtaValue = subSection ? `${subSection}:${ctaValue}` : ctaValue
  return {
    'data-section': `Content:${pageZone}`,
    'data-position': position,
    'data-translation': composedCtaValue,
  }
}

export { createOnClickTrackingHandler, getTrackingConfigLinkAttributes }
